import { useCustomersService } from '@/views/Customers/services/customersService'

export function createCustomersActions(state) {
    const customersService = useCustomersService()

    const fetchCustomers = async (queryString = '') => {
        try {
            state.customersLoading.value = true
            const response = await customersService.fetchCustomers(queryString)
            state.customers.value = response.data.results || []
            return response
        } catch (error) {
            throw error
        } finally {
            state.customersLoading.value = false
        }
    }

    const fetchCustomerById = async (customerId) => {
        try {
            state.customersLoading.value = true
            const response = await customersService.fetchCustomerById(customerId)
            state.customer.value = response.data
            return response.data
        } catch (error) {
            throw error
        } finally {
            state.customersLoading.value = false
        }
    }

    const createCustomer = async (customerData) => {
        try {
            state.customersLoading.value = true
            return await customersService.createCustomer(customerData)
        } catch (error) {
            throw error
        } finally {
            state.customersLoading.value = false
        }
    }

    const updateCustomer = async (customerData) => {
        try {
            state.customersLoading.value = true
            return await customersService.updateCustomer(customerData)
        } catch (error) {
            throw error
        } finally {
            state.customersLoading.value = false
        }
    }

    const deleteCustomer = async (customerId) => {
        try {
            state.customersLoading.value = true
            return await customersService.deleteCustomer(customerId)
        } catch (error) {
            throw error
        } finally {
            state.customersLoading.value = false
        }
    }

    const getCustomerAddresses = async (customerId) => {
        try {
            return await customersService.getCustomerAddresses(customerId)
        } catch (error) {
            throw error
        }
    }

    const getCustomerTypes = async () => {
        try {
            const response = await customersService.getCustomerTypes()
            state.customersTypes.value = response.data.results
            return response
        } catch (error) {
            throw error
        }
    }

    const getAddressTypes = async () => {
        try {
            const response = await customersService.getAddressTypes()
            state.addressTypes.value = response.data.results
            return response
        } catch (error) {
            throw error
        }
    }

    const getCountries = async () => {
        try {
            const response = await customersService.getCountries()
            state.countries.value = response.data.results
            return response
        } catch (error) {
            throw error
        }
    }

    const getProductionFileCustomerConfiguration = async () => {
        try {
            const response = await customersService.getProductionFileCustomerConfiguration()
            state.productionFileCustomerConfiguration.value = response.data.results
            return response
        } catch (error) {
            throw error
        }
    }

    return {
        fetchCustomers,
        fetchCustomerById,
        createCustomer,
        updateCustomer,
        deleteCustomer,
        getCustomerAddresses,
        getCustomerTypes,
        getAddressTypes,
        getCountries,
        getProductionFileCustomerConfiguration
    }
}
